import { Component, OnInit, inject } from '@angular/core';
import { Background } from '../../shared/components/background/background';
import { Connect } from '../../shared/components/connect/connect';
import { HeroSection } from '../../shared/components/hero-section/hero-section';
import { DevelopmentProjects } from './components/development-projects/development-projects';
import { InfoCard } from '../../shared/components/info-card/info-card';
import { SeoService } from '../../shared/services/seo.service';

@Component({
  selector: 'app-development-case-studies',
  imports: [Background, HeroSection, Connect, DevelopmentProjects, InfoCard],
  templateUrl: './development-case-studies.html',
  styleUrl: './development-case-studies.scss'
})
export class DevelopmentCaseStudies implements OnInit {

  protected file = 'development-case-studies';

  private seo = inject(SeoService);

  ngOnInit() {
    this.seo.apply({
      title: 'Development Case Studies',
      description: 'See SEM Nexus app development case studies covering UX/UI, agile builds, and launch results showing how we turn ideas into scalable mobile apps.',
      canonical: '/development-case-studies/',
      image: 'https://semnexus.com/images/development-case-studies/backgrounds/development-case-studies.avif',
      imageAlt: 'SEM Nexus mobile app development case studies',
      type: 'website',
    });
    this.seo.setBreadcrumbs([
      { name: 'Home', url: '/' },
      { name: 'Development Case Studies' },
    ]);
  }
}
